import request from "@/utils/request.js"

const auth = {
  captchaImage: () => request.get("/api/System/Auth/CaptchaImage"),
  login: params => request.get("/api/System/Auth/Login", { params }),
  menus: () => request.get("/api/System/Auth/Menus"),
  actions: () => request.get("/api/System/Auth/Actions")
}

//数据字典
const meta = {
  typeList: params => request.get("/api/System/Meta/TypeList", { params }),
  typeInfo: params => request.get("/api/System/Meta/TypeInfo", { params }),
  typeSave: params => request.post("/api/System/Meta/SubmitType", params),
  typeDelete: params => request.get("/api/System/Meta/DeleteType", { params }),

  itemList: params => request.get("/api/System/Meta/ItemList", { params }),
  itemInfo: params => request.get("/api/System/Meta/ItemInfo", { params }),
  itemSave: params => request.post("/api/System/Meta/SubmitItem", params),
  itemDelete: params => request.get("/api/System/Meta/DeleteItem", { params }),
}

//菜单管理
const menu = {
  getTree: params => request.get("/api/System/Module/getList", { params }),
  getData: params => request.get("/api/System/Module/GetInfo", { params }),
  submit: params => request.post("/api/System/Module/Submit", params),
  delete: params => request.get("/api/System/Module/Delete", { params })
}


//功能管理
const action = {
  getList: params => request.post("/api/System/Action/GetList", params),
  update: params => request.post("/api/System/Action/Submit", params),
  create: params => request.get("/api/System/Action/Generate", { params })
}

//角色管理
const role = {
  getList: params => request.get("/api/System/Role/GetList", { params }),
  getData: params => request.get("/api/System/Role/GetInfo", { params }),
  submit: params => request.post("/api/System/Role/Submit", params),
  delete: params => request.get("/api/System/Role/Delete", { params }),
  auth: {
    actions: params => request.post("/api/System/Authorize/GetActions", params),
  },
  limit: {
    setting: params => request.post("/api/System/Authorize/SetLimit", params),
    delete: params => request.get("/api/System/Authorize/DelLimit", { params })
  }
}

//用户管理
const user = {
  getList: params => request.post("/api/System/User/GetList", params),
  getLogs: params => request.post("/api/System/User/GetLogs", params),
  getData: params => request.get("/api/System/User/GetInfo", { params }),
  submit: params => request.post("/api/System/User/Submit", params),
  setPassword: params => request.post("/API/System/User/SetPassword", params),
  resetPassword: params => request.get("/api/System/User/ResetPassword", { params })
}

//授权管理
const authorize = {
  getList: params => request.post("/API/System/Authorize/List", params),
  submit: params => request.post("/API/System/Authorize/Submit", params)
}

//文件管理
const file = {
  list: params => request.post("/api/System/File/GetList", params),
  delete: params => request.get("/api/System/File/Delete", { params })
}

//消息管理
const message = {
  getSends: params => request.post("/api/Message/GetSends", params),
  getInfo: params => request.get("/api/Message/GetInfo", { params }),
  submit: params => request.post("/api/Message/Submit", params),
  reply: params => request.post("/api/Message/Reply", params),
  delete: params => request.get("/api/Message/Delete", { params })
}
/***
 * 操作记录
 */
const record = {
  list: params => request.get("/api/System/Record/GetList", { params }),
  submit: params => request.post("/api/System/Record/Submit", params),
}

export default {
  auth,
  meta,
  menu,
  action,
  role,
  user,
  authorize,
  file,
  message,
  record
}
